/**
 * @generated SignedSource<<9da503976ea2a1ac00c74238c0aaa28e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldDefinitionInput = {
  id?: string | null;
  displayName?: string | null;
  readOnly?: boolean | null;
  avaRef?: number | null;
  showOnOpportunityList?: boolean | null;
  showOnProjectList?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateCustomFieldDefinitionMutation$variables = {
  input: UpdateCustomFieldDefinitionInput;
};
export type UpdateCustomFieldDefinitionMutation$data = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly displayName: string | null;
        readonly avaRef: number | null;
        readonly showOnOpportunityList: boolean;
        readonly showOnProjectList: boolean;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation$rawResponse = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly displayName: string | null;
        readonly avaRef: number | null;
        readonly showOnOpportunityList: boolean;
        readonly showOnProjectList: boolean;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation = {
  variables: UpdateCustomFieldDefinitionMutation$variables;
  response: UpdateCustomFieldDefinitionMutation$data;
  rawResponse: UpdateCustomFieldDefinitionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showOnOpportunityList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showOnProjectList",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39e94941a12fac9554166f0bad9c4134",
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDefinitionMutation(\n  $input: UpdateCustomFieldDefinitionInput!\n) {\n  updateCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        displayName\n        avaRef\n        showOnOpportunityList\n        showOnProjectList\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5bd743935af9d41c0392c67a9e1e7c3";

export default node;
